<template>
    <div class="detail-container">
      <component :is="currentContent" :survey="surveyObj" @toDetailAnalysisChild="toDetailAnalysis" />
    </div>
  </template>

<script>
import Results from './Results.vue'; //Survey results and analytics
import Details from './Details.vue'; //Survey details
import Blank from './Blank.vue'; //Blank page
import Feedback from './Feedback.vue'; 



export default {
    name: 'DetailContainer',
  props: {
    contentType: String, // Prop to determine which content to display
    surveyObj: Object, // Prop to pass survey object to child components
  },
  components: {
    Results,
    Details,
    Blank,
    Feedback,
  },
  data() {
    return {
      isLoading: false, // Assuming you have isLoading in your data
    };
  },
  computed: {
    currentContent() {
      // Return the appropriate component based on contentType
      switch (this.contentType) {
        case 'results':
          return 'Results';
        case 'responses':
          return 'Responses';
        case 'details':
          return 'Details';
        case 'testers':
          return 'Testers';
        case 'feedback':
          return "Feedback"
        default:
          return 'Blank'; // Default to Results if contentType is not specified
      }
    },
  },
  methods: {
    toDetailAnalysis() {
      // Implement the toDetailAnalysis method if needed
    },
  },
};
</script>

<style scoped>
.detail-container {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 60%;
  margin: 0 2%;
  height: 75vh;
    overflow-y: scroll;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.detail-container::-webkit-scrollbar {
    width: 0;
    display: false;
}
</style>


// WEBPACK FOOTER //
// src/components/game-detail/Surveys/DetailContainer.vue